/**
 * Takes an object and an Array of method names and returns a plain object mapping each method name
 * to a version of the method bound to the given object.
 *
 * Example usage:
 *
 * ```
 * class MyButton extends React.Component {
 *   constructor() {
 *     super();
 *
 *     this.state = {
 *       ...
 *     };
 *
 *     this.bound = bindMethods(this, ['onClick', 'onFocus']);
 *   }
 *
 *   onClick() {
 *     this.setState(...);
 *   }
 *
 *   onFocus() {
 *     this.setState(...);
 *   }
 *
 *   render() {
 *     return (
 *       <button onClick={this.bound.onClick} onFocus={this.bound.onFocus}>
 *         My button
 *       </button>
 *     );
 *   }
 * }
 * ```
 */
export default function bindMethods(object, methods) {
  const getMethod = (methods instanceof Array
                     ? name => object[name]
                     : name => methods[name]);

  const methodNames = (methods instanceof Array
                       ? methods
                       : Object.keys(methods));

  const boundMethods = {};

  methodNames.forEach(name => {
    const m = getMethod(name);
    if (!m) {
      throw new Error(`Attempting to bind method '${name}', but method was not found.`);
    }
    boundMethods[name] = m.bind(object);
  });

  return boundMethods;
}
